import { useNavigate } from 'react-router-dom'
import bg from '../Image/loading_bg.png'

const Loading = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#cbc0a3] text-white px-4">

        <img src={bg} alt="Loading..." className='w-40 sm:w-56 md:w-72 lg:w-80 mb-6' />
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-8 font-bold text-[#533700] text-center">
          Rock Paper Scissors
        </h1>

        <button
          onClick={() => navigate("/Game")}
          className="bg-[#533700] 
  px-4 sm:px-6 md:px-8 
  py-2 sm:py-3 
  text-base sm:text-lg md:text-xl 
  rounded-lg 
  hover:bg-[#845b0a] 
  transition 
  w-26 sm:w-30"
        >
          ▶ Play Game
        </button>

      </div>
    </div>
  )
}

export default Loading